export const SAVE_ALL_PERMISSIONS = 'SAVE_ALL_PERMISSIONS'
export const SAVE_PERMISSION = 'SAVE_PERMISSION'
